var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTypeImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9948 0.660156H1.91238C1.64579 0.660156 1.39013 0.769867 1.20163 0.965152C1.01313 1.16044 0.907227 1.4253 0.907227 1.70148V14.1973C0.907227 14.4735 1.01313 14.7384 1.20163 14.9337C1.39013 15.129 1.64579 15.2387 1.91238 15.2387H17.9948C18.2614 15.2387 18.517 15.129 18.7055 14.9337C18.894 14.7384 18.9999 14.4735 18.9999 14.1973V1.70148C18.9999 1.4253 18.894 1.16044 18.7055 0.965152C18.517 0.769867 18.2614 0.660156 17.9948 0.660156V0.660156ZM13.2203 4.30478C13.5535 4.30478 13.8731 4.44192 14.1087 4.68603C14.3444 4.93014 14.4767 5.26122 14.4767 5.60644C14.4767 5.95166 14.3444 6.28274 14.1087 6.52684C13.8731 6.77095 13.5535 6.90809 13.2203 6.90809C12.8871 6.90809 12.5675 6.77095 12.3319 6.52684C12.0962 6.28274 11.9639 5.95166 11.9639 5.60644C11.9639 5.26122 12.0962 4.93014 12.3319 4.68603C12.5675 4.44192 12.8871 4.30478 13.2203 4.30478V4.30478ZM3.92268 12.1147L7.25374 4.18087L11.0422 10.535L14.2898 8.86369L15.9845 12.1147H3.92268Z",
    fill: "#6F6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeImg);
export default __webpack_public_path__ + "static/media/type-img.ed70937efd79203806d3de9cd6b59394.svg";
export { ForwardRef as ReactComponent };